// Display-name resolver — Phase 7 Block B.
//
// Looks up a playerId in self + zone-roster snapshot and returns the
// best presentation string. Falls back to shortenId for offline /
// out-of-zone players whose display_name we don't have cached.
//
// Pure function so panels can call it from their build/render path
// without owning a name cache. The data comes from clientState which
// is already the source of truth for self + visible peers.

import type { PlayerState } from "../../shared/messages.ts";
import { shortenId } from "./market-ui-widgets.ts";

export type DisplayNameSource = {
  self: PlayerState | null;
  players: Map<string, PlayerState>;
};

export function resolveDisplayName(playerId: string, src: DisplayNameSource): string {
  if (src.self !== null && src.self.playerId === playerId && src.self.displayName !== "") {
    return src.self.displayName;
  }
  const peer = src.players.get(playerId);
  if (peer !== undefined && peer.displayName !== "") return peer.displayName;
  return shortenId(playerId);
}
